// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel[data-v-497574cf]{width:1400px;margin:0 auto}.el-carousel__item img[data-v-497574cf]{width:100%;height:100%}.el-carousel--horizontal[data-v-497574cf]{overflow-x:hidden;overflow-y:hidden}", ""]);
// Exports
module.exports = exports;
